import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

const FOOTER_LINKS = {
  "Bonus Türleri": [
    { to: "/bonuses/trial", label: "Deneme Bonusu" },
    { to: "/bonuses/no-deposit", label: "Yatırımsız Bonus" },
    { to: "/bonuses/free-spins", label: "Bedava Dönüş" },
    { to: "/bonuses/no-wager", label: "Çevrimsiz Bonus" },
  ],
  Kaynaklar: [
    { to: "/comparisons", label: "Karşılaştırma" },
    { to: "/guides", label: "Rehberler" },
    { to: "/bonus-rules", label: "Bonus Kuralları" },
    { to: "/brands", label: "Tüm Firmalar" },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t border-border/60 bg-card" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand column */}
          <div className="sm:col-span-2 lg:col-span-2">
            <Link to="/" className="mb-4 flex items-center gap-2.5">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary">
                <Zap className="h-4 w-4 text-primary-foreground" />
              </div>
              <span className="text-base font-bold tracking-tight text-foreground">
                DenemeBonus<span className="text-primary">.ai</span>
              </span>
            </Link>
            <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
              Akıllı bonus analiz platformunuz. Deneme bonusları, yatırımsız teklifler,
              bedava dönüşler ve bonus koşullarını veriye dayalı içgörülerle karşılaştırın.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
            <div key={heading}>
              <h3 className="mb-3 text-sm font-semibold text-foreground">
                {heading}
              </h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-muted-foreground transition-colors hover:text-primary"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-border/60 pt-6 sm:flex-row">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} DenemeBonus.ai — Bonus Analiz Platformu.
            Yalnızca bilgilendirme amaçlıdır.
          </p>
          <p className="text-xs text-muted-foreground">
            Eğitim ve analiz içerikleri. Kumar operatörü değildir.
          </p>
        </div>
      </div>
    </footer>
  );
}
